<template>
  <div class="doyac-admin">
    <slot name="loading">
      <DYLandingScreen />
    </slot>

    <notifications />

    <v-app v-if="!mainStore.isLanding" :theme="isDark ? 'dark' : 'light'" :class="[
      adminMainStore.personalSetting.miniSideBar ? 'mini-sidebar' : '',
      customizer.setHorizontalLayout ? 'horizontalLayout' : 'verticalLayout',
    ]">
      <LcFullCustomizer />
      <LcFullVerticalHeader v-if="!customizer.setHorizontalLayout" />
      <LcFullVerticalSidebar v-if="!customizer.setHorizontalLayout">
        <template #favorite>
          <v-list-group v-if="adminMainStore.personalSetting && adminMainStore.personalSetting.favoriteMenu.length > 0"
            class="mb-0">
            <template #activator="{ props }">
              <v-list-item rounded="lg" v-bind="props">
                <template #prepend>
                  <v-icon class="text-white" icon="far fa-star" />
                </template>
                <v-list-item-title>
                  즐겨찾기
                </v-list-item-title>
              </v-list-item>
            </template>
            <VueDraggableNext :list="adminMainStore.personalSetting.favoriteMenu">
              <v-list-item v-for="entry in adminMainStore.personalSetting.favoriteMenu" rounded="lg"
                :key="entry.to ? entry.to : entry.href" :to="entry.to" :href="entry.href" :target="entry.target"
                :style="`padding-inline-start: ${12 + (16 * 1)}px !important`" class="!min-h-11 rounded-none">
                <v-list-item-title>{{ entry.title }}</v-list-item-title>
                <template v-slot:append>
                  <v-btn color="grey-lighten-1" variant="text" size="small"
                    @click.stop.prevent="adminMainStore.removeFavoriteMenu(entry)">
                    <template #append>
                      <v-icon class="mr-1 !text-lg" icon="far fa-trash" />
                    </template>
                  </v-btn>
                  <!--                  <v-btn color="grey-lighten-1" icon="far fa-trash" variant="text"
                                           @click.stop.prevent="adminMainStore.removeFavoriteMenu(entry)" />-->
                </template>
              </v-list-item>
            </VueDraggableNext>
          </v-list-group>
        </template>

        <DYAMenu :menu="adminMainStore.menu" />

        <!-- 개발자 전용 메뉴 -->
        <template v-if="isEngineer">
          <!-- <MiscDYGroupMenu v-for="(val, key) in leftMenu1" v-bind="val" :key="key" /> -->
        </template>

        <slot name="leftMenuIngang"></slot>
      </LcFullVerticalSidebar>

      <v-main>
        <!-- <div v-if="mainStore.isLoading"
          class="h-screen w-screen fixed bg-zinc-950 bg-opacity-50 z-[5000] flex items-center justify-center"
          @click="mainStore.isLoading = false">
          <MiscDYLoading :is-teleport="true" />
        </div> -->

        <LcFullHorizontalHeader v-if="customizer.setHorizontalLayout" />
        <LcFullHorizontalSidebar v-if="customizer.setHorizontalLayout" />
        <!-- page-wrapper 클래스 있었음 -->
        <v-container v-if="!mainStore.isLanding" fluid>
          <div v-if="classs">
            <slot name="default"></slot>
          </div>
          <v-btn v-if="isAdmin" class="customizer-btn bg-primary !text-base" variant="tonal" icon="far fa-cog"
            color="white" size="small" @click.stop="customizer.SET_CUSTOMIZER_DRAWER(!customizer.Customizer_drawer)" />

          <DYInstantMessage v-if="userStore.isSignedIn"></DYInstantMessage>
        </v-container>
      </v-main>
      <v-navigation-drawer v-model="adminMainStore.pageHelpMemoNavSettings.isMainOpened" location="right" temporary
        width="600">
        <div class="flex justify-end p-2">
          <v-btn icon="fas fa-times" color="primary" size="small"
            @click="adminMainStore.pageHelpMemoNavSettings.isMainOpened = false"></v-btn>
        </div>
        <div class="p-4">
          <DYAPageHelpMemoViewer type="main" />
        </div>
      </v-navigation-drawer>
      <v-navigation-drawer v-model="adminMainStore.pageHelpMemoNavSettings.isSectionOpened" location="right" floating
        width="600" :persistent="false">
        <div class="flex justify-end p-2">
          <v-btn icon="fas fa-times" color="primary" size="small"
            @click="adminMainStore.pageHelpMemoNavSettings.isSectionOpened = false"></v-btn>
        </div>
        <div class="p-4">
          <DYAPageHelpMemoViewer type="section" />
        </div>
      </v-navigation-drawer>

      <!-- 로그인 만료 안내 다이얼로그 -->
      <ModalDYDialog v-model:dialog-control="showTokenExpiredDialog" title="세션 만료" persistent :footer="false">
        <v-container class="p-4">
          <v-alert color="red" variant="tonal">
            로그인이 만료되었습니다. 다시 로그인해주세요.
          </v-alert>

          <div class="flex justify-end gap-2 mt-4">
            <v-btn @click="showTokenExpiredDialog = false">취소</v-btn>
            <v-btn color="blue" @click="router.push('/login')">로그인 하기</v-btn>
          </div>
        </v-container>
      </ModalDYDialog>
    </v-app>
  </div>
</template>

<script setup lang="ts">
import { useDark, useToggle, useDocumentVisibility } from '@vueuse/core'
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCalendar,
  faCashRegister,
  faCircle as farCircle,
  faComments,
  faDotCircle as farDotCircle,
  faEnvelope,
  faGear,
  faHammer,
  faHome,
  faInbox,
  faList,
  faMoneyBill,
  faPersonWalking,
  faPhone,
  faReceipt,
  faRectangle,
  faSquare as farSquare,
  faStar as farStar,
  faTrash,
  faUsers,
  faClipboardList,
  faCards,
  faArrowUpArrowDown, faPencil, faSquarePollVertical, faUserCrown, faDatabase, faNetworkWired,
  faAlarmClock
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowDown as fasArrowDown,
  faArrowsAltV as fasArrowsAltV,
  faArrowUp as fasArrowUp,
  faBars as fasBars,
  faCalendar as fasCalendar,
  faCaretDown as fasCaretDown,
  faCheck as fasCheck,
  faCheckCircle as fasCheckCircle,
  faCheckSquare as fasCheckSquare,
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faChevronUp as fasChevronUp,
  faCircle as fasCircle,
  faEdit as fasEdit,
  faExclamation as fasExclamation,
  faExclamationTriangle as fasExclamationTriangle,
  faInfoCircle as fasInfoCircle, faMessage,
  faMinus as fasMinus,
  faMinusSquare as fasMinusSquare,
  faPaperclip as fasPaperclip,
  faPlus as fasPlus,
  faStar as fasStar,
  faStarHalf as fasStarHalf,
  faStepBackward as fasStepBackward,
  faStepForward as fasStepForward,
  faSync as fasSync,
  faTimes as fasTimes,
  faTimesCircle as fasTimesCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { H3Error } from 'h3';
import { VueDraggableNext } from 'vue-draggable-next';
import { ForbiddenError, UnauthorizedError, useDYAuth } from "~/modules/nuxt3-module-doyac/composables/auth";
import { useDYMainStore } from '~/modules/nuxt3-module-doyac/stores/main';
import { useDYAppConfig } from '~~/modules/nuxt3-module-doyac/composables/config';
import { useCustomizerStore } from "../../stores/customizer";
import { useDYAdminMainStore } from "../../stores/main";
import { DEFAULT_SETTINGS, type DYAPersonalSetting } from '../../composables/dya-personal-setting';
import { cloneDeep, debounce, isEqual } from 'lodash-es';
import dayjs from "dayjs";
import { useDYAFirebaseMessaging } from "~/modules/nuxt3-module-admin-doyac/composables/dya-firebase-messaging";

// Vuetify가 각종 컴퍼넌트에서 기본적으로 사용하는 아이콘들. 여기서 추가된 아이콘은 다른 곳에서는 별도로 추가할 필요가 없다.
// 자세한 아이콘 목록은 vuetify\lib\iconsets\fa.mjs 파일 참고.
library.add(
  // fas
  fasChevronUp, fasCheck, faComments, fasTimesCircle, fasTimes, fasCheckCircle, fasInfoCircle, fasExclamation,
  fasExclamationTriangle, fasChevronLeft, fasChevronRight, fasCheckSquare, fasMinusSquare, fasCircle,
  fasArrowUp, fasArrowDown, fasChevronDown, fasBars, fasCaretDown, fasEdit, fasStar, fasStarHalf,
  fasSync, fasStepBackward, fasStepForward, fasArrowsAltV, fasPaperclip, fasPlus, fasMinus, fasCalendar,
  // far
  farSquare, farDotCircle, farCircle, farStar, faHammer, faHome, faUsers, faInbox, faTrash, faGear,
  faReceipt, faMoneyBill, faEnvelope, faRectangle, faPhone, faList, faCashRegister, faPersonWalking, faClipboardList,
  faCards, faArrowUpArrowDown, faSquarePollVertical, faUserCrown, faCalendar, faPencil,
  faDatabase, faNetworkWired, faAlarmClock
)

const isDark = useDark()
const toggleDark = useToggle(isDark)

const userStore = $dy__useDYUserStore()
const customizer = useCustomizerStore()
const mainStore = useDYMainStore()
const adminMainStore = useDYAdminMainStore()
const { isEngineer, isAdmin, isTeacher, isCEO, isTeamLeader, isPartner } = useDYAuth()
const { siteName, creatorNameKo, fullDomain } = useDYAppConfig()
const {
  init: initFirebaseMessaging,
  deleteToken: deleteFirebaseMessagingToken
} = useDYAFirebaseMessaging()

const route = useRoute()
const router = useRouter()

const title = ref(siteName);
let _oldPersonalSetting: DYAPersonalSetting = DEFAULT_SETTINGS

const titleAppend = computed(() => {
  if (isTeacher.value) return creatorNameKo
  if (isAdmin.value) return '관리자'
  if (isPartner.value) return '파트너'
})

const setFontSize = (size: number) => {
  const html = document.getElementsByTagName('html').item(0)
  if (html) {
    html.style.fontSize = `${size}px`
  }
}

const debouncedSyncPersonalSetting = debounce(adminMainStore.syncPersonalSetting, 100)

setFontSize(adminMainStore.personalSetting.fontSize)

useHead({
  meta: [{ content: title }],
  titleTemplate: (titleChunk) => {
    return titleChunk
      ? `${titleChunk}`
      : `${siteName}`
  }
});

useSeoMeta({
  robots: "noindex, nofollow",
})

// 2026-06-11 syncLegacy(구 세션 동기화 /mer/oauth/sync-legacy) 호출 제거.
// 관리자 프로젝트는 전부 creator.* 서브도메인으로 분리되어 www(세션 호스트)와 cross-origin이라
// CSRF 토큰이 어긋나 항상 419만 발생 → 무의미한 요청이므로 제거함.
// (dy-default.ts의 syncLegacy 자체는 유저 프로젝트에서 쓰일 수 있어 유지)

watch(() => adminMainStore.personalSetting, (val) => {
  if (isEqual(val, _oldPersonalSetting)) {
    return
  }

  setFontSize(val.fontSize)
  debouncedSyncPersonalSetting()

  _oldPersonalSetting = cloneDeep(val)
}, {
  deep: true
})

onMounted(async () => {
  await userStore.ready()

  mainStore.isLoading = false

  // document.title = document.title + ' '+titleAppend.value;
  document.title = siteName + ' ' + titleAppend.value;

  //배포 버전과 똑같이 테일윈드 CSS의 우선도를 가장 높이기 위함
  let elements = document.querySelectorAll('style')
  for (let elem of elements) {
    if (elem instanceof HTMLStyleElement && elem.innerText.includes('tailwindcss')) {
      document.getElementsByTagName('body')[0].prepend(elem)
    }
  }

  // 세션스토리지에서 doyac-page-help-memo- 로 시작하는 키값 제거
  // 2026-10-23 수정(신고 #17): 지우면서 앞으로 세면 다음 키가 당겨져 하나 건너 하나만 지워졌다 → 먼저 모은 뒤 삭제
  const helpMemoKeys: string[] = []
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i)
    if (key && key.startsWith('doyac-page-help-memo-')) helpMemoKeys.push(key)
  }
  helpMemoKeys.forEach(key => sessionStorage.removeItem(key))

  // 관리자 페이지에서는 URL 해시를 쓰지 않음. 오히려 있으면 useDYPagination이 사용된 페이지에서 버그가 생기므로 강제로 제거시킴.
  if (route.hash) {
    router.replace({ hash: undefined })
  }

  if (isAdmin.value) {

    adminMainStore.menu = [
      {
        id: 'main',
        title: '메인',
        to: '/',
        icon: faHome
      },
      {
        title: '회원관리',
        isHeader: true
      },
      {
        id: 'users',
        title: '회원',
        icon: faUsers,
        to: '/users',
        children: [
          {
            id: 'live-users',
            title: '회원목록',
            icon: faUsers,
            to: '/users'
          },
          {
            id: 'expired-users',
            title: '휴면회원',
            icon: faUsers,
            to: '/users/expired'
          },
          {
            id: 'del-users',
            title: '탈퇴회원',
            icon: faUsers,
            to: '/users/delmember',
          },
          {
            id: 'shared-users',
            title: '아이디공유',
            icon: faUsers,
            to: '/users/blackId',
          },
          {
            id: 'captcha-users',
            title: '캡챠/차단IP 목록',
            icon: faUsers,
            to: '/users/blackIpCapcha'
          },
          {
            id: 'block-users',
            title: '공격 히스토리',
            icon: faUsers,
            to: '/users/blackIp'
          },

        ]
      },
      {
        id: 'group-message',
        title: '메시지/메일/전화상담',
        icon: faEnvelope,
        children: [
          {
            id: 'message-log',
            title: '메시지 내역',
            icon: faMessage,
            to: '/message'
          },
          {
            id: 'mail-log',
            title: '이메일 발송 내역',
            icon: faEnvelope,
            to: '/mail'
          },
          {
            id: 'help-call-lists',
            title: '전화상담 요청',
            icon: faPhone,
            to: '/payments/help-request?status=request&status=proceeding',
          }
        ]
      },
      {
        id: 'payment-management-header',
        title: '결제관리',
        isHeader: true
      },
      {
        id: 'group-payment-management',
        title: '결제관리',
        icon: faMoneyBill,
        children: [
          {
            id: 'manual-pay-list',
            title: '맞춤결제요청',
            icon: faCashRegister,
            to: '/payments/manual-payments'
          },
          {
            id: 'deposit-list',
            title: '무통장입금',
            icon: faReceipt,
            to: '/payments/deposit'
          },
          {
            id: 'cash-receipt-list',
            title: '현금영수증',
            icon: faReceipt,
            to: '/payments/cash-receipts'
          }
        ],
      },

      // {
      //   id: 'group-users',
      //   title: '회원관리',
      //   icon: faUsers,
      //   children: [
      //     {
      //       id: 'users',
      //       title: '회원목록',
      //       icon: faUsers,
      //       to: '/users'
      //     },
      //     {
      //       id: 'group-users-lv2',
      //       title: '회원관리 Lv2',
      //       icon: faUsers,
      //       children: [
      //         {
      //           id: 'group-users-lv3',
      //           title: '회원목록 Lv3',
      //           icon: faUsers,
      //           // auth: 'teacher',
      //           children: [
      //             {
      //               id: 'users-lv3',
      //               title: '회원목록 Lv3',
      //               icon: faUsers,
      //               to: '/users'
      //             },
      //           ]
      //         },
      //         {
      //           id: 'lv2-a',
      //           title: 'Lv2 A',
      //           // auth: 'teacher'
      //         },
      //         {
      //           title: '서브메뉴 헤더',
      //           isHeader: true
      //         },
      //         {
      //           id: 'lv2-b',
      //           title: 'Lv2 B',
      //           to: '/lv2-b'
      //         },
      //       ]
      //     }
      //   ]
      // },
      {
        id: 'event-manager',
        title: '포인트/이벤트/배너',
        isHeader: true
      },
      {
        id: 'site-manager',
        title: '사이트관리',
        isHeader: true
      },
      {
        id: 'manager-default',
        title: '게시판관리',
        icon: faClipboardList,
        children: [
          {
            id: 'admin-notice',
            title: '관리자 공지',
            icon: faUserCrown,
            to: `/admin/notice`,
          },
          {
            id: 'board-ranking-list',
            title: '게시글 랭킹 관리',
            icon: faArrowUpArrowDown,
            to: `/admin/boardRanking`,
          },
          {
            id: 'board-manager',
            title: '게시판 등록/수정',
            icon: faRectangle,
            to: `/admin/boardManager`,
          },
          {
            id: 'fast-reply',
            title: '빠른답변',
            icon: faPencil,
            to: '/siteManage/quickReplies',
          },
          {
            id: 'personal-qna',
            title: '1:1문의 관리',
            icon: faPencil,
            to: '/siteManage/personalQna',
          },
          {
            id: 'research-management',
            title: '설문관리',
            icon: faSquarePollVertical,
            to: '/research',
          },
        ]
      },
      {
        id: 'review-manage',
        title: '수강평 관리',
        icon: faGear,
        to: '/siteManage/reviews'
      },
      {
        id: 'log-header',
        title: '각종 기록',
        isHeader: true
      },
      {
        id: 'calendar-management-header',
        title: '캘린더',
        isHeader: true
      },
      {
        id: 'calendar-default',
        title: '캘린더관리',
        icon: faCalendar,
        children: [
          {
            id: 'individual-calendar',
            title: '개인',
            icon: faCalendar,
            to: '/calendar/1' // 260320 쿼리 파라미터에서 path 파라미터로 변경 (메뉴 하이라이트 중복 문제 해결)
          },
          {
            id: 'record-calendar',
            title: '촬영일정',
            icon: faCalendar,
            to: '/calendar/2?group=doyac' // 260320 쿼리 파라미터에서 path 파라미터로 변경
          },
          {
            id: 'holiday-calendar',
            title: '연차',
            icon: faCalendar,
            to: '/calendar/3?group=doyac' // 260320 쿼리 파라미터에서 path 파라미터로 변경
          }
        ]
      },
      {
        id: 'company-management-header',
        title: '사내관리',
        isHeader: true
      },
      {
        id: 'electronic-authorization',
        title: '전자결재',
        icon: faInbox,
        to: '/electronicAuthorization?status=default&eaType=y'
      },
      {
        id: 'electronic-authorization',
        title: '비용처리',
        icon: faMoneyBill,
        to: `/toExpense`,
      },
      // 2026-08-27 추가 — 관리자 리마인더. 화면 우측 상단 알람시계 버튼으로 건 예약을 여기서 조회/중단/삭제한다.
      //   ⚠ upcoming-work 앞에 둔다. 아래에서 addMenu('upcoming-work', 매출관리헤더)로 매출관리 섹션을
      //     upcoming-work 바로 뒤에 붙이기 때문에, 뒤에 두면 사내관리 그룹 사이에 헤더가 끼어든다.
      {
        id: 'my-reminder',
        title: '내 리마인더',
        icon: faAlarmClock,
        to: '/reminder'
      },
      {
        id: 'upcoming-work',
        title: '콘텐츠 업무예정',
        icon: faList,
        to: '/upcomingWork?id=' + userStore.id
      },
      {
        id: 'ai-header',
        title: 'AI',
        isHeader: true
      },
      {
        id: 'ai-chat',
        title: 'AI 채팅',
        icon: faComments,
        to: '/ai'
      },
      {
        // 2026-10-14 AI 부서 제안함 (마케팅·기획·서비스 AI 가 올린 제안서를 승인·재검토). 설계: doyac/laravel/app/Extensions/AI_PROPOSAL.md
        id: 'ai-proposal',
        title: 'AI 제안함',
        icon: faClipboardList,
        to: '/aiProposal'
      },
    ]
    if (isCEO.value || isTeamLeader.value || isEngineer.value) {
      adminMainStore.addMenu('upcoming-work', {
        id: 'sales-management-header',
        title: '매출관리',
        isHeader: true
      }, 'append')
      adminMainStore.addMenu('sales-management-header', {
        id: 'total-sales',
        title: '전체매출',
        icon: faReceipt,
        to: '/sales/totalSales',
      }, 'append')
      adminMainStore.addMenu('total-sales', {
        id: 'tax-for-sales',
        title: '과세/면세 통계',
        icon: faReceipt,
        to: '/sales/totalTaxType',
      }, 'append')
      adminMainStore.addMenu('tax-for-sales', {
        id: 'sales-by-goods',
        title: siteName === '마이퍼스트가이드' ? '투어별 매출현황' : '강의별 매출현황',
        icon: faReceipt,
        to: `/sales/course`,
      }, 'append')
      adminMainStore.addMenu('sales-by-goods', {
        id: 'sales-by-creator',
        title: '선생님별 매출통계',
        icon: faReceipt,
        to: '/sales/teacher',
      }, 'append')
      // 2026-04-21 구 PHP 페이지(total_Sales_Partner_List.php) 포팅 완료로 링크 교체
      adminMainStore.addMenu('sales-by-creator', {
        id: 'partner-sales',
        title: '파트너사별 매출',
        icon: faReceipt,
        to: '/sales/partner',
      }, 'append')

      if (siteName !== '마이퍼스트가이드') {
        adminMainStore.addMenu('partner-sales', {
          id: 'monthly-sales-tax',
          title: '월별 원천징수 현황',
          icon: faReceipt,
          to: '/sales/withHoldingTax'
        }, 'append')
        adminMainStore.addMenu('monthly-sales-tax', {
          id: 'monthly-sales-board',
          title: '월별 게시판 정산',
          icon: faReceipt,
          to: '/sales/board'
        }, 'append')
      }

    }
    if (isCEO.value) {
      adminMainStore.addMenu(siteName !== '마이퍼스트가이드' ? 'monthly-sales-board' : 'partner-sales', {
        id: 'ceo-management-header',
        title: '대표전용',
        isHeader: true
      }, 'append')
      adminMainStore.addMenu('ceo-management-header', {

        id: 'commute-history',
        title: '출퇴근기록',
        icon: faInbox,
        to: '/commuteRecord'
      }, 'append')
      adminMainStore.addMenu('commute-history', {

        id: 'holiday-history',
        title: '연차관리',
        icon: faInbox,
        to: '/holidayManage'
      }, 'append')
      adminMainStore.addMenu('holiday-history', {
        id: 'ad-inflow-and-pay',
        title: '광고유입&결제',
        icon: faInbox,
        to: '/siteManage/logAdVsPay'
      }, 'append')
      adminMainStore.addMenu('ad-inflow-and-pay', {
        id: 'ad-by-ip',
        title: 'IP그룹별 광고관리',
        icon: faInbox,
        to: '/siteManage/logAdIpGroup'
      }, 'append')
      adminMainStore.addMenu('ad-by-ip', {
        id: 'email-manager',
        title: '이메일 등록',
        icon: faInbox,
        to: '/emailAccount'
      }, 'append')
    }
  }

  await adminMainStore.loadPersonalSetting()

  try {
    initFirebaseMessaging()
  } catch (e: any) {
    console.error(e)
  }
})

// 로그인 만료 타이머 및 모달 처리
const showTokenExpiredDialog = ref(false)
let tokenExpireTimer: number | undefined

const clearTokenExpireTimer = () => {
  if (tokenExpireTimer) {
    clearTimeout(tokenExpireTimer)
    tokenExpireTimer = undefined
  }
}

const scheduleTokenExpireDialog = (expirationTimestamp?: number | null) => {
  clearTokenExpireTimer()

  // 만료 타임스탬프 원천값 (store 우선)
  let exp = typeof expirationTimestamp === 'number' ? expirationTimestamp : userStore.tokenExpiration

  if (!exp) return

  // 초 단위(10자리)면 ms로 변환
  if (exp < 1e12) { // 자리수 따지기 위함
    exp = exp * 1000
  }

  const remainMs = exp - Date.now() // 항상 ms 기준

  if (remainMs <= 0) {
    // accessToken이 유효한 상태라면 만료 다이얼로그를 띄우지 않음.
    // 로그인 성공 후 페이지 이동 시 쿠키는 갱신됐지만 computed가 아직
    // 이전 값을 반환하는 타이밍에 이 분기에 잘못 진입하는 문제를 방지.
    if (userStore.accessToken) return
    showTokenExpiredDialog.value = true
    return
  }

  showTokenExpiredDialog.value = false // 세션만료 후 새로 로그인해서 돌아왔을 때 모달이 닫히도록
  tokenExpireTimer = window.setTimeout(() => {
    showTokenExpiredDialog.value = true
  }, remainMs) // 밀리 세컨드로 해야만 적용
}

watch(() => userStore.tokenExpiration, (exp) => {
  if (process.server) return
  scheduleTokenExpireDialog(exp)
}, { immediate: true }) //immediate를 해야만 감시 시작과 동시에 콜백을 한번 실행시킴

const visibility = useDocumentVisibility()
watch(visibility, (current, previous) => {
  if (current === 'visible') {
    scheduleTokenExpireDialog()
  }
})

// 페이지 이동 시에도 세션 만료 체크. 260311 원래는 route.fullpath였는데 이렇게 하니 모달을 눌렀을 때 발생하는 해시 등록에도 반응하여 메모가 안보이게 되는 문제가 있어서 path로 변경.
watch(() => route.path, () => {
  scheduleTokenExpireDialog()
  adminMainStore.resetPageHelpMemoNavSettings() //이게 있어야 하는 이유는 페이지 메모 설정이 있는 페이지에서 없는 페이지로 이동시에 이게 없으면 해당 페이지의 설정이 이전 페이지의 설정이 되버림(메모도 잘못 보임)
})

onBeforeUnmount(() => {
  clearTokenExpireTimer()
})

onErrorCaptured((e: any) => {
  // 핸들링되지 않은 Nuxt의 fetch 메서드에 의해 발생한 에러인 경우. 보통 필수가 아닌 상황이므로 별도의 에러 처리를 하지
  // 않는다.
  if (e instanceof H3Error) {
    console.error('ERROR CAPTURED??????', e.name, e.message, e.toString())
  } else if (e instanceof UnauthorizedError) {
    console.error('UnauthorizedError!!!')
    router.replace(e.loginUrl)
  } else if (e instanceof ForbiddenError) {
    console.error('ForbiddenError!!!')
    // 원래는 에러가 난 페이지에 다시 접근했을 때 페이지가 다시 생성될 수 있도록 하기 위하여 에러를 스토어에 저장하고
    // 에러 페이지로 이동시켜서 처리했으나 관리자 페이지는 이 기능이 필요가 없으므로(관리자 페이지는 keep-alive를 사용하지
    // 않으므로 의미가 없음) 그냥 기본 에러처리 방식으로도 충분함. 또한 이렇게 해야 에러가 난 페이지 URL에서 그대로 멈춘다.
    showError({ statusCode: 403 })
    // errorStore.lastGlobalError = { statusCode: 403 }
    // router.replace('/error')
  } else {
    showError(e) // 위 ForbiddenError와 마찬가지로 관리자 페이지는 굳이 에러 페이지로 보낼 필요가 없음.
    // errorStore.lastGlobalError = e
    // router.replace('/error')
  }
})

const classs = "page-enter";
</script>

<style scoped>
:deep(.v-list-item__spacer) {
  width: 0 !important;
}

:deep(.v-list-item__prepend > .v-icon) {
  margin-inline-end: 8px !important;
}

:deep(.v-list-item),
:deep(.v-list-subheader) {
  min-height: 44px !important;
}

:deep(.v-navigation-drawer--rail:not(.v-navigation-drawer--is-hovering)) {
  .v-list-item-title,
  .v-list-item__append {
    display: none !important;
  }
}

.doyac-admin:deep(.vue-notification-group) {
  top: 15px !important;
  right: 15px !important;
}
</style>